import * as Yup from 'yup';
import { descriptionOptional, nameRequired, numberRequired, stringOptional, stringRequired } from '.';

export const addTaskListItemSchema = Yup.object({
    list_id: numberRequired,
    title: nameRequired,
    description: descriptionOptional,
    due_date: stringRequired,
    due_time: stringRequired,
    labels: stringOptional,
    label_color_tag: stringRequired
});